export const getPriority = (days) => {
  if (days >= 0 && days < 20) return 1;
  if (days >= 20 && days <= 30) return 2;
  if (days > 30) return -1;

  return 0;
};

export const getUnvistedSiteAnalytic = (data) => {
  const total = data.length;
  const critical = data.filter((s) => s.daysSinceLastVisit > 30).length;
  const avg =
    total > 0
      ? Math.round(
          data.reduce((sum, s) => sum + s.daysSinceLastVisit, 0) / total,
        )
      : 0;
  return { total, critical, avg };
};

export function siteCategoryColor(stateValue) {
  const colorsMap = {
    Pending: "text-yellow-500",
    Installation: "text-sec-blue",
    Testing: "text-green",
    Deactivated: "text-lg3",
  };

  return colorsMap[stateValue] || "";
}

export function getmaterialTransportStatus(status) {
  const statusMap = {
    0: { status: "Pending", color: "text-yellow-500" },
    1: { status: "Completed", color: "text-green" },
  };

  return statusMap[status] || "";
}
